import {observable, computed, action} from 'mobx';
import {getIn} from '../utils';
import createSelector, {LruCacheObject} from 're-reselect';

export class MasterData {
  @observable content = {};

  constructor(api) {
    this.api = api;
  }

  @action async fetch() {
    if(this._loadingPromise) {
      return this._loadingPromise;
    }
    try{
      if(Object.keys(this.content).length === 0) {
        this._loadingPromise = this.api.getMasterData();   
        this.content = await this._loadingPromise;
      }
    }
    finally {
      this._loadingPromise = undefined;
    }
  }

  cFetch = createSelector(
    [p => p],
    (p) => this.fetch(p)
  )(
    () => 
      ``,
    {cacheObject: new LruCacheObject({cacheSize: 1}), }
  );  

  @computed get optSalutations() {
    return getIn(this.content, ['salutations'], []).map(o => {
      return {value: o.Id, text: o.Name};
    })
  }

  salutationTextByValue(value) {
    const salutation = this.optSalutations.find(o => o.value === value);
    if(!salutation) {
      return '';
    }
    return salutation.text;
  } 

  @computed get optCountries() {
    return getIn(this.content, ['countries'], []).map(o => {
      return {value: o.Id, text: o.Name};
    })
  } 

  countryTextByValue(value) {
    const country = this.optCountries.find(o => o.value === value);
    if(!country) {
      return '';
    }
    return country.text;
  }   

  @computed get optLanguages() {
    return getIn(this.content, ['languages'], []).map(o => {
      return {value: o.Id, text: o.Name};
    })
  } 

  languageTextByValue(value) {
    const language = this.optLanguages.find(o => o.value === value);
    if(!language) {
      return '';
    }
    return language.text;
  }  

  @computed get optTimeZones() {
    return getIn(this.content, ['timeZones'], []).map(o => {
      return {value: o.Id, text: o.Name};
    })
  } 

  timeZoneTextByValue(value) {
    const timeZone = this.optTimeZones.find(o => o.value === value);
    if(!timeZone) {
      return '';
    }
    return timeZone.text;
  }  
}


// WEBPACK FOOTER //
// ./src/model/MasterData.js